import { UPDATE_NEWCHECKOUT_STATE } from "./newCheckout.types";
import {
  SET_LOGGEDIN_USER,
} from "../../redux/loggedInUser/loggedInUser.types";
import backendApi from "../../api/backendApi";
import {
  CREATE_USER_QUERY,
  Update_USER_Mutation,
} from "../../constants/queries/user";
import { setLoadingState } from "../loader/loader.actions";
import { errorToast } from "../../utils/toasts";
import { AppDispatch } from "../store";

export const updateNewCheckoutState =
  (data: any) => (dispatch: AppDispatch) => {
    dispatch({
      type: UPDATE_NEWCHECKOUT_STATE,
      payload: data,
    });
  };
  
export const setLoggedInUser = (data: any) => (dispatch: AppDispatch) => {
  dispatch({
    type: SET_LOGGEDIN_USER,
    payload: data,
  });
  if (data && data._id) {
    dispatch(updateNewCheckoutState({ newCheckoutFlow: false }));
  } else {
    dispatch(updateNewCheckoutState({ newCheckoutFlow: true }));
  }
};
export const updateAndCheckoutNewUser =
  (user: any, userData: any, cart: any, tax: any, cb: Function) =>
  async (dispatch: AppDispatch) => {
    try {
      const userRes = await backendApi.post("/", {
        query: Update_USER_Mutation,
        variables: {
          _id: userData._id,
          country: user.country,
          country_code: user.countryCode
            ? parseInt(user.countryCode)
            : userData.country_code,
          email: user.email.toLowerCase(),
          mobile: parseFloat(user.mobile),
          name: user.name,
          type: user.type,
          gst: userData.gst ? userData.gst : "",
          company: userData.companyName ? userData.companyName : "",
          city: userData?.city ? userData?.city : "",
          state: userData.state ? userData.state : "",
        },
      });
      if (userRes.data.errors?.length)
        throw new Error(userRes.data.errors[0].message);

      dispatch(
        updateNewCheckoutState({
          newUserData: { ...userRes.data.data.updateUser },
        })
      );

      cb();
    } catch (error: any) {
      dispatch(setLoadingState(false));
      errorToast(error.message);
    }
  };

export const checkoutNewUser =
  (user: any, cart: any, tax: any, cb: Function) =>
  async (dispatch: AppDispatch) => {
    try {
      const obj = cart.items[0].concernedArea && {
        concerned_area: cart.items[0].concernedArea.toLowerCase(),
      };
      const userData = await backendApi.post("/", {
        query: CREATE_USER_QUERY,
        variables: {
          email: user.email.toLowerCase(),
          name: user.name,
          mobile: parseFloat(user.mobile),
          country: user.country,
          countryCode: parseInt(user.countryCode),
          type: user.type,
          state: user.state,
          device: user.device,
          device_type: user.device_type,
          page_url: user.page_url,
          user_agent: user.user_agent,
          user_ip_address: user.user_ip_address,
          source: user.source,
          ...obj,
        },
      });

      if (userData.data.errors?.length)
        throw new Error(userData.data.errors[0].message);

      // dispatch(
      //   updateNewCheckoutState({
      //     newUserData: { ...userData.data.data.createUser },
      //   }),
      // );
      localStorage.setItem(
        "ezyLegalUserData",
        JSON.stringify(userData.data.data.createUser)
      );
      dispatch(setLoggedInUser(userData.data.data.createUser));

      if (cb) cb();
    } catch (error: any) {
      errorToast(error.message);
      dispatch(setLoadingState(false));
    }
  };

export const updateCheckoutUser =
  (user: any, userData: any, cb: Function) => async (dispatch: AppDispatch) => {
    try {
      const userRes = await backendApi.post("/", {
        query: Update_USER_Mutation,
        variables: {
          _id: userData._id,
          city: user?.city,
          company: user?.companyName !== null ? user?.companyName : "",
          country_code: userData.country_code,
          email: user?.email.toLowerCase(),
          gst: user?.gst !== null ? user.gst : "",
          mobile: parseFloat(user?.number),
          name: user?.name,
          state: user?.state,
        },
      });
      if (userRes.data.errors?.length)
        throw new Error(userRes.data.errors[0].message);

      dispatch(
        updateNewCheckoutState({
          newUserData: { ...userRes.data.data.updateUser },
        })
      );

      cb();
    } catch (error: any) {
      dispatch(setLoadingState(false));
      errorToast(error.message);
    }
  };
